import { ViewportSetter } from './ViewportSetter';

const viewportSetter = new ViewportSetter();

export { viewportSetter };
